module.exports = __webpack_public_path__ + "static/media/Home_Banner.31938962.png";